export default "__VITE_ASSET__8133742a__"